import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import api from '../../api/api'

export const admin_get_installments = createAsyncThunk(
    'installment/admin_get_installments',
    async ({ page = 1, parPage = 15, status = 'all' } = {}, { rejectWithValue, fulfillWithValue }) => {
        try {
            const { data } = await api.get('/admin/installments', {
                params: { page, parPage, status }
            })
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response?.data)
        }
    }
)

export const admin_get_installment = createAsyncThunk(
    'installment/admin_get_installment',
    async (id, { rejectWithValue, fulfillWithValue }) => {
        try {
            const { data } = await api.get(`/admin/installments/${id}`)
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response?.data)
        }
    }
)

export const admin_confirm_bank_transfer = createAsyncThunk(
    'installment/admin_confirm_bank_transfer',
    async ({ id, scheduleId, paymentRef, notes }, { rejectWithValue, fulfillWithValue }) => {
        try {
            const { data } = await api.put(`/admin/installments/${id}/confirm-bank/${scheduleId}`, {
                paymentRef,
                notes
            })
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response?.data)
        }
    }
)

export const update_installment_settings = createAsyncThunk(
    'installment/update_installment_settings',
    async (settings, { rejectWithValue, fulfillWithValue }) => {
        try {
            const { data } = await api.put('/admin/installment-settings', settings)
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response?.data)
        }
    }
)

export const installmentReducer = createSlice({
    name: 'installment',
    initialState: {
        installments: [],
        totalInstallments: 0,
        selectedInstallment: null,
        successMessage: '',
        errorMessage: '',
        loader: false
    },
    reducers: {
        messageClear: (state) => {
            state.successMessage = ''
            state.errorMessage = ''
        },
        clearSelectedInstallment: (state) => {
            state.selectedInstallment = null
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(admin_get_installments.fulfilled, (state, { payload }) => {
                state.installments = payload.installments
                state.totalInstallments = payload.total
            })
            .addCase(admin_get_installment.fulfilled, (state, { payload }) => {
                state.selectedInstallment = payload.installment
            })
            .addCase(admin_confirm_bank_transfer.pending, (state) => {
                state.loader = true
            })
            .addCase(admin_confirm_bank_transfer.fulfilled, (state, { payload }) => {
                state.loader = false
                state.successMessage = payload.message
            })
            .addCase(admin_confirm_bank_transfer.rejected, (state, { payload }) => {
                state.loader = false
                state.errorMessage = payload?.error || 'Confirmation failed'
            })
            .addCase(update_installment_settings.fulfilled, (state, { payload }) => {
                state.successMessage = payload.message
            })
            .addCase(update_installment_settings.rejected, (state, { payload }) => {
                state.errorMessage = payload?.error || 'Settings update failed'
            })
    }
})

export const { messageClear, clearSelectedInstallment } = installmentReducer.actions
export default installmentReducer.reducer
